import { makeDynamicDataLoader } from './factory';

export const { init, get, load } = makeDynamicDataLoader('timezones', (set, client) =>
  client.venues.getVenueTimezones().then(data => set(data.timezones))
);
